import axiosV2Instance from './axiosV2Instance';

export interface PaymentAllocationEntryV2 {
  allocationId: number;
  paymentLineId: number;
  paymentLineType?: string;
  paymentLineDescription?: string;
  paymentLineAmount: number;
  allocationAmount: number;
  allocationDate: string;
  allocationType: string;
  sessionId?: number;
  sessionActivityId?: number; // ID активности для подчеркивания
  contractId?: number;
  sessionUserName?: string;
  sessionSiteName?: string;
  sessionActivityTypeOfWorkName?: string; // Название вида работы активности
  sessionTimeStart?: string;
  sessionTimeEnd?: string;
  sessionHours?: number;
  contractTitle?: string;
  contractDescription?: string;
  contractFixedAmount?: number;
}

export interface PaymentAllocationLineInfoV2 {
  id: number;
  type: string;
  description: string;
  amount: number;
  isAllocated: boolean;
  dateCreated: string;
}

export interface PaymentAllocationPaymentInfoV2 {
  id: number;
  userId?: number;
  siteExecutorId?: number;
  userName: string;
  amount: number;
  documentAmount?: number;
  allocatedAmount: number;
  remainingAmount: number;
  date?: string;
  adminSignature: boolean;
  userSignature: boolean;
  isFullyAllocated: boolean;
}

export interface PaymentAllocationDetailsV2 {
  payment: PaymentAllocationPaymentInfoV2;
  paymentLines: PaymentAllocationLineInfoV2[];
  activityAllocations: PaymentAllocationEntryV2[];
  contractAllocations: PaymentAllocationEntryV2[];
  totalAllocatedAmount: number;
  remainingAmount: number;
  totalAllocations: number;
}

class PaymentAllocationV2Api {
  async getPaymentAllocations(paymentId: number, siteId: number): Promise<PaymentAllocationDetailsV2> {
    const response = await axiosV2Instance.get<PaymentAllocationDetailsV2>(`/sites/${siteId}/payment-allocations/payment/${paymentId}`);
    return response.data;
  }
}

export const paymentAllocationV2Api = new PaymentAllocationV2Api();

